import { render, staticRenderFns } from "./AddStaffConvertIds.vue?vue&type=template&id=71e2072a"
import script from "./AddStaffConvertIds.vue?vue&type=script&lang=js"
export * from "./AddStaffConvertIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports